var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import useMediaQuery from "@mui/material/useMediaQuery";
import { CrossIcon } from "../../../../../assets/customIcons";
import { DynamicFormBuilderContainer } from "../../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
import { FormItemTypes } from "../../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { DisabledTrashIcon, FeatureIcon, PlusBlueIcon, TrashIcon } from "../../../../fieldFailureReports/assets/svg";
import { CourierDetailsDataGrid } from "./CourierDetailsDataGrid";
import { Typography } from "@mui/material";
import { v4 } from "uuid";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import dayjs from "dayjs";
import { getDealerIdList } from "../../../services/apiCalls";
import { FileAttachmentComponent } from "../../../../fieldFailureReports/components/FrequentComponent";
export var ResubmitPopUp = function (_ref) {
    var onClose = _ref.onClose, request = _ref.request;
    var lgMode = useMediaQuery(function (theme) { return theme.breakpoints.up("sm"); });
    var formData = [{
            type: FormItemTypes.IconButton,
            name: 'icon',
            label: '',
            value: null,
            children: /*#__PURE__*/ React.createElement(FeatureIcon, {
                sx: {
                    fontSize: 48
                }
            }),
            columnSize: true
        }, {
            type: FormItemTypes.IconButton,
            name: 'close',
            label: '',
            value: null,
            children: /*#__PURE__*/ React.createElement(CrossIcon, {
                sx: {
                    fontSize: 12
                }
            }),
            onClick: onClose,
            columnSize: 0
        }, {
            type: FormItemTypes.Typography,
            name: 'Msg',
            label: "Are you sure you want to Resubmit?",
            value: null,
            columnSize: 12,
            children: "Actions taken cannot be undone.",
            color: 'text.secondary',
            labelTypographyProps: {
                fontSize: "xl",
                fontWeight: "strong",
                color: "text.primary"
            }
        }, {
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            elements: [{
                    type: FormItemTypes.CardComponent,
                    name: '',
                    columnSize: 12,
                    sx: {
                        p: 1
                    },
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: 'PreviouslySubmittedSample',
                            columnSize: 12,
                            label: 'Previously submitted samples:',
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'sm'
                            },
                            containerProps: {
                                display: 'flex',
                                direction: 'row',
                                justifyContent: 'space-between'
                            }
                        }]
                }, {
                    type: FormItemTypes.CardComponent,
                    name: "Courier",
                    columnSize: 12,
                    contentProps: {},
                    elements: [{
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            columnSize: 0,
                            spacing: 0,
                            justifyContent: 'flex',
                            alignItems: 'center',
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: "sub_heading",
                                    labelTypographyProps: {
                                        fontSize: "base",
                                        fontWeight: "strong",
                                        color: "text.primary"
                                    },
                                    bgcolor: "red",
                                    label: "Courier attachment",
                                    columnSize: true
                                }, {
                                    type: FormItemTypes.Attachment,
                                    name: "CourierAttachment",
                                    value: null,
                                    inputProps: {
                                        accept: [".xlsx", ".csv"]
                                    },
                                    columnSize: 0,
                                    attachmentButtonProps: {
                                        sx: {
                                            display: "none"
                                        }
                                    },
                                    // uploadAttachmentAPI: UploadAttachmentAPICall,
                                    setFieldProps: function (formValues, currentValue) {
                                        var result = currentValue === null || currentValue === void 0 ? void 0 : currentValue.find(function (item) { return item.IsDeleted == 0 || (item === null || item === void 0 ? void 0 : item.name); });
                                        return {
                                            type: FormItemTypes.Attachment,
                                            uploadButtonProps: {
                                                variant: "text",
                                                color: "primary",
                                                disabled: result
                                            }
                                        };
                                    }
                                }]
                        }, {
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            setFieldProps: function (formValues, currValue, field, formApi) {
                                var _formValues$CourierAt;
                                var result = (_formValues$CourierAt = formValues.CourierAttachment) === null || _formValues$CourierAt === void 0 ? void 0 : _formValues$CourierAt.find(function (item) { return item.IsDeleted == 0 || (item === null || item === void 0 ? void 0 : item.name); });
                                return {
                                    type: FormItemTypes.ContainerItem,
                                    columnSize: 12,
                                    elements: [result ? {
                                            type: FormItemTypes.CardComponent,
                                            name: "",
                                            columnSize: 12,
                                            elements: [{
                                                    type: FormItemTypes.Custom,
                                                    name: "CourierAttachment",
                                                    columnSize: 12,
                                                    element: FileAttachmentComponent,
                                                    validator: function (value, state) {
                                                        var _value$;
                                                        if ((value === null || value === void 0 || (_value$ = value[0]) === null || _value$ === void 0 ? void 0 : _value$.size) > 5 * 1024 * 1024)
                                                            return "Max file size allowed is 5MB";
                                                        return "";
                                                    }
                                                }]
                                        } : null]
                                };
                            }
                        }]
                }]
        }, lgMode ? {
            type: FormItemTypes.Custom,
            name: "CourierData",
            element: CourierDetailsDataGrid,
            columnSize: 12
        } : null, !lgMode ? {
            type: FormItemTypes.CardComponent,
            name: '',
            sx: {
                p: 0,
                pt: 2,
                border: 0,
                borderRadius: 0
            },
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    sx: {
                        border: "none"
                    },
                    columnSize: 12,
                    elements: [{
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            columnSize: 12,
                            justifyContent: "center",
                            display: "flex",
                            spacing: 0,
                            alignItems: 'center',
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: 'ads',
                                    value: 'Courier details',
                                    fontWeight: 'bold',
                                    columnSize: true
                                }, {
                                    type: FormItemTypes.Button,
                                    name: 'AddCourierData',
                                    variant: 'text',
                                    startIcon: /*#__PURE__*/ React.createElement(PlusBlueIcon, {
                                        color: "primary"
                                    }),
                                    setFormState: function (formValues, value) {
                                        var _formValues$CourierDa, _formValues$CourierDa2;
                                        console.log("formValues?.CourierData?.length====>", formValues === null || formValues === void 0 || (_formValues$CourierDa = formValues.CourierData) === null || _formValues$CourierDa === void 0 ? void 0 : _formValues$CourierDa.length);
                                        return {
                                            CourierData: __spreadArray(__spreadArray([], ((formValues === null || formValues === void 0 ? void 0 : formValues.CourierData) || []), true), [{
                                                    id: v4(),
                                                    CourierName: "",
                                                    DealerName: "",
                                                    BookingDate: '',
                                                    DocketNumber: '',
                                                    NoOfSample: '',
                                                    Remark: '',
                                                    BranchId: '',
                                                    Courier: ((formValues === null || formValues === void 0 || (_formValues$CourierDa2 = formValues.CourierData) === null || _formValues$CourierDa2 === void 0 ? void 0 : _formValues$CourierDa2.length) || 0) + 1
                                                }], false)
                                        };
                                    },
                                    columnSize: 0
                                }, {
                                    type: FormItemTypes.Button,
                                    name: 'DelteCourierData',
                                    variant: 'text',
                                    startIcon: /*#__PURE__*/ React.createElement(TrashIcon, null),
                                    sx: {
                                        pr: 3
                                    },
                                    setFieldProps: function (currentValue) {
                                        var _currentValue$Courier;
                                        var hasSelectedItem = currentValue === null || currentValue === void 0 || (_currentValue$Courier = currentValue.CourierData) === null || _currentValue$Courier === void 0 ? void 0 : _currentValue$Courier.some(function (item) { return item.Selected; });
                                        return {
                                            type: FormItemTypes.Button,
                                            startIcon: hasSelectedItem ? /*#__PURE__*/ React.createElement(TrashIcon, null) : /*#__PURE__*/ React.createElement(DisabledTrashIcon, null),
                                            disabled: !hasSelectedItem,
                                            sx: {
                                                display: !(currentValue !== null && currentValue !== void 0 && currentValue.ParamsBeforeRepairExpanded) ? "none" : null
                                            }
                                        };
                                    },
                                    setFormState: function (fromValues, value) {
                                        var _fromValues$CourierDa;
                                        var filteredData = (fromValues === null || fromValues === void 0 || (_fromValues$CourierDa = fromValues.CourierData) === null || _fromValues$CourierDa === void 0 ? void 0 : _fromValues$CourierDa.filter(function (item) { return !item.Selected; })) || [];
                                        var updatedData = filteredData.map(function (item, index) { return _objectSpread(_objectSpread({}, item), {}, {
                                            Courier: index + 1
                                        }); });
                                        return {
                                            CourierData: updatedData
                                        };
                                    },
                                    columnSize: 0
                                }, {
                                    type: FormItemTypes.Button,
                                    name: 'expand-button',
                                    columnSize: 0,
                                    color: 'secondary',
                                    size: 'small',
                                    sx: {
                                        p: 0,
                                        fontSize: 'sm'
                                    },
                                    setFormState: function (formValues) {
                                        return {
                                            ParamsBeforeRepairExpanded: !(formValues !== null && formValues !== void 0 && formValues.ParamsBeforeRepairExpanded)
                                        };
                                    },
                                    setFieldProps: function (formValues) {
                                        var value = formValues !== null && formValues !== void 0 && formValues.id ? formValues === null || formValues === void 0 ? void 0 : formValues.ParamsBeforeRepairExpanded : !(formValues !== null && formValues !== void 0 && formValues.ParamsBeforeRepairExpanded);
                                        return {
                                            type: this.type,
                                            children: value ? [/*#__PURE__*/ React.createElement(ExpandLess, null)] : [/*#__PURE__*/ React.createElement(ExpandMore, null)]
                                        };
                                    }
                                }]
                        }]
                }, {
                    type: FormItemTypes.Accordian,
                    name: 'ParamsBeforeRepairExpanded',
                    value: false,
                    summaryProps: {
                        sx: {
                            display: 'none'
                        }
                    },
                    summary: [],
                    setFieldProps: function (formValues, currValue, field) {
                        return {
                            type: FormItemTypes.Accordian,
                            expanded: formValues !== null && formValues !== void 0 && formValues.id ? currValue : !currValue
                        };
                    },
                    sx: {
                        bgcolor: 'background.secondary',
                        border: 'none'
                    },
                    columnSize: 12,
                    elements: [{
                            type: FormItemTypes.List,
                            name: 'CourierData',
                            columnSize: 12,
                            variant: 'compact',
                            value: null,
                            columns: [{
                                    field: 'CourierName',
                                    flex: 1,
                                    renderCell: function (_ref2) {
                                        var row = _ref2.row;
                                        return /*#__PURE__*/ React.createElement(Typography, {
                                            p: 1,
                                            fontWeight: "bold",
                                            fontSize: 'md'
                                        }, "Courier ".concat(row === null || row === void 0 ? void 0 : row.Courier));
                                    }
                                }],
                            elements: [{
                                    type: FormItemTypes.ContainerItem,
                                    name: '',
                                    columnSize: 12,
                                    p: 1,
                                    spacing: 1,
                                    elements: [{
                                            type: FormItemTypes.TextInput,
                                            name: 'CourierName',
                                            label: 'Courier Name:',
                                            columnSize: 12
                                        }, {
                                            type: FormItemTypes.SearchSelect,
                                            label: "Dealer ID",
                                            name: "BranchId",
                                            value: null,
                                            required: true,
                                            getListData: getDealerIdList,
                                            apiRequest: {
                                                id: request === null || request === void 0 ? void 0 : request.id
                                            },
                                            displayExpr: "Name",
                                            valueExpr: "id",
                                            getOptionLabel: function (option) { return option ? "".concat(option.BranchName, " - ").concat(option.BranchCode) : ""; }
                                        }, {
                                            type: FormItemTypes.DatePicker,
                                            name: 'BookingDate',
                                            label: 'Booking date',
                                            value: dayjs(),
                                            setFieldProps: function (formValues) { return ({
                                                type: FormItemTypes.DatePicker,
                                                value: dayjs(formValues === null || formValues === void 0 ? void 0 : formValues.BookingDate).isValid() ? dayjs(formValues.BookingDate) : dayjs()
                                            }); }
                                        }, {
                                            type: FormItemTypes.TextInput,
                                            name: 'DocketNumber',
                                            label: 'Docket Number',
                                            columnSize: 12
                                        }, {
                                            type: FormItemTypes.TextInput,
                                            name: 'NoOfSample',
                                            label: 'No Of Sample',
                                            columnSize: 12
                                        }]
                                }],
                            getRowHeight: function () { return 'auto'; }
                        }]
                }]
        } : null, {
            type: FormItemTypes.TextInput,
            name: 'Remark',
            multiline: true,
            label: 'ASM remarks:',
            required: true,
            minRows: 4,
            columnSize: 12,
            validator: function (value, state) {
                var nameRegex = /^[A-Za-z\s]+$/;
                var leadingSpacesRegex = /^\S.*$/;
                // Optional: block completely empty or all-space input
                if (!leadingSpacesRegex.test(value) && (value === null || value === void 0 ? void 0 : value.length) > 0) {
                    return "Leading spaces are not allowed.";
                }
                if (!nameRegex.test(value) && (value === null || value === void 0 ? void 0 : value.length) > 0) {
                    return 'Only alphabetic characters are allowed';
                }
                if ((value === null || value === void 0 ? void 0 : value.length) < 5) {
                    return 'ASM remarks must be at least 5 characters';
                }
                if ((value === null || value === void 0 ? void 0 : value.length) > 250) {
                    return 'ASM remarks by must be no longer than 250 characters';
                }
                return undefined;
            }
        }, {
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            spacing: 0,
            gap: 1,
            justifyContent: 'end',
            alignItems: 'center',
            elements: lgMode ? [{
                    type: FormItemTypes.Button,
                    name: 'cancel',
                    children: 'Cancel',
                    fullWidth: true,
                    variant: 'outlined',
                    size: 'small',
                    sx: {
                        py: 1,
                        color: "secondary.500",
                        border: '1px solid',
                        fontWeight: "medium",
                        borderColor: 'secondary.200',
                        fontSize: "base"
                    },
                    onClick: function () {
                        onClose(false);
                    }
                }, {
                    type: FormItemTypes.Button,
                    name: 'Confirm',
                    children: 'Confirm',
                    fullWidth: true,
                    variant: 'contained',
                    size: 'small',
                    sx: {
                        py: 1,
                        color: "primary",
                        backgroundColor: "primary",
                        fontWeight: "medium",
                        fontSize: "base"
                    },
                    onClick: function () { return 'submit'; }
                }] : [{
                    type: FormItemTypes.Button,
                    name: 'Confirm',
                    children: 'Confirm',
                    fullWidth: true,
                    variant: 'contained',
                    size: 'small',
                    sx: {
                        py: 1,
                        color: "primary",
                        backgroundColor: "primary",
                        fontWeight: "medium",
                        fontSize: "base"
                    },
                    onClick: function () { return 'submit'; }
                }, {
                    type: FormItemTypes.Button,
                    name: 'cancel',
                    children: 'Cancel',
                    fullWidth: true,
                    variant: 'outlined',
                    size: 'small',
                    sx: {
                        py: 1,
                        color: "secondary.500",
                        border: '1px solid',
                        fontWeight: "medium",
                        borderColor: 'secondary.200',
                        fontSize: "base"
                    },
                    onClick: function () {
                        onClose();
                    }
                }]
        }];
    return /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData,
        formProps: {
            sx: {
                m: 2
            }
        },
        mode: "edit",
        gridProps: {
            spacing: 0,
            gap: "20px"
        },
        getFormAPI: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, {
                        success: true,
                        data: request
                    }];
            });
        }); },
        updateFormAPI: function (_ref3) { return __awaiter(void 0, void 0, void 0, function () {
            var request;
            return __generator(this, function (_a) {
                request = _ref3.request;
                onClose(request);
                return [2 /*return*/, {
                        success: true
                    }];
            });
        }); }
        // createFormAPI={FieldFailureReportSubmitAPI}
        // createKey={FieldFailureReportsKeys.update}
        // createRequest={{ 
        //     id: row?.id , 
        //     StatusId:row?.StatusId,
        //     IsSubmit:1,
        //     onClose,
        // }}
    });
};
